export default "__VITE_ASSET__4ea5ffe0__"